import axiosInstance from "../../../axios/Axios";

export function requestSaveSteps(action) {
  return () => {
    const { steps, product } = action.payload;
    const assemblysteps = steps.map((step) => {
      return {
        element: {
          id: step.id,
          data: step.data,
          type: step.type,
          position: step.position,
          source: step.source,
          sourceHandle: step.sourceHandle,
          target: step.target,
          label: step.label,
          animated: step.animated,
          targetHandle: step.targetHandle,
        },
        product: product.id,
        step: step.step,
        element_id: step.id,
      };
    });
    console.log(steps);
    axiosInstance.put(`/products/productassembly/` + product.id + `/`, {
      name: product.name,
      id: product.id,
      assemblysteps: assemblysteps,
    });
  };
}

export function requestGetAllSteps(action) {
  return axiosInstance.get(
    `/products/productassembly/` + action.payload + `/assemblysteps/`
  );
}

// export function requestAddStep(action) {
//   return () => {
//     const data = action.payload;
//     axiosInstance.post(`/products/assemblystep/create/`, {
//       product: data.product,
//       name: "empty",
//       element: data.element,
//       element_id: data.element.id,
//       step: "empty",
//     });
//   };
// }
